import { FormattedMessage } from 'react-intl';
import * as mobxReact from 'mobx-react';
import React, { useContext } from 'react';
import { AttendeeAdditionalInfo } from '../../../_events/_manage-event/shared/attendees-section/_attendee/_attendee-presentation/attendee-additional-info';
import AttendeeNotesSection from '../../../_events/_manage-event/shared/attendees-section/_attendee-notes-section/_attendee-notes-section';
import { UNDERLINE_REG_EXP } from '../../../../constants/regex.constants';
import { IAttendeeNote } from '../../../../api/attendees.dao';
import { Permission } from '../../../../api/roles.dao';
import { EventDetailsContext } from '../../../global.context';

interface IProps {
    issues: string[];
    notes: IAttendeeNote[];
    attendeeInfo;
    attendeeId: number;
    openAttendeePopover: () => void;
    handleAttendeeRemoval: () => void;
    withIssues?: boolean;
    withNotes?: boolean;
    withRemove?: boolean;
    handleAttendeeCopy?: () => void;
    editPermission?: Permission;
}

const PopoverContent = mobxReact.observer((props: IProps) => {
    const {
        issues,
        notes,
        attendeeInfo,
        openAttendeePopover,
        handleAttendeeRemoval,
        withIssues = false,
        withNotes = false,
        withRemove = false,
        handleAttendeeCopy,
        editPermission,
    } = props;
    const context = useContext(EventDetailsContext);
    const eventTimezone = context?.eventDetails?.eventTimezone ?? '';

    const formatIssuesString = (array: string[]) => {
        return array?.join(', ').replace(UNDERLINE_REG_EXP, ' ').toLowerCase();
    };

    return (
        <div onDoubleClick={e => e.stopPropagation()} >
            {withIssues && issues.length ?
                <div className='attendee-column-popover__issues'>
                    <p>{formatIssuesString(issues)}</p>
                </div> : null}
            <AttendeeAdditionalInfo
                attendeeInfo={attendeeInfo}
                handleClick={openAttendeePopover}
                withRemove={withRemove}
                handleRemoveClick={handleAttendeeRemoval}
                handleCopy={handleAttendeeCopy}
                editPermission={editPermission}
            />
            {withNotes && notes.length ? <AttendeeNotesSection
                notes={notes}
                eventTimezone={eventTimezone}
                title={<FormattedMessage
                    id='oe.common.notes'
                    description='Label text'
                    defaultMessage='{prefix}Notes'
                    values={{
                        prefix: 'Operator Meeting '
                    }}
                />}
            /> : null}
        </div>
    );
});

export default PopoverContent;
